import * as React from 'react'
import styled from 'styled-components'
import { Input as UIkitInput } from '@swapxco/uikit'
import { getNeomorphismBoxShadowValue } from '../../theme/utils'

export const SwapXInput = UIkitInput